<!-- 商户管理 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left"></div>
        <div class="right">
          <el-input
            type="text"
            placeholder="请输入订单号"
            v-model="keyword"
            class="input_box"
          />
          <el-input
            type="text"
            placeholder="请输入会员名"
            v-model="keyword"
            class="input_box"
          />
          <el-input
            type="text"
            placeholder="请输入商户"
            v-model="keyword"
            class="input_box"
          />
          <el-input
            type="text"
            placeholder="请输入门店名称"
            v-model="keyword"
            class="input_box"
          />
          <el-button type="primary" @click="search()">搜索</el-button>
          <el-button @click="clear()">清除</el-button>
        </div>
      </div>
      <!-- 商户列表 -->
      <CommodityTable :tableData="listData"></CommodityTable>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <div class="changePage">
          <div @click="upPage" class="btnColor">
            <span>上一页</span>
          </div>
          <div>
            <span>{{ page }}</span>
          </div>
          <div @click="downPage" class="btnColor">
            <span>下一页</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommodityTable from "./tables/commodityTable";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    CommodityTable
  },
  data() {
    return {
      menus: "商户列表",
      listData: [
        {
          id: 1,
          image_url:
            "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3273639253,4215472728&fm=26&gp=0.jpg",
          cname: "爆款夏季休闲长裤",
          pp: "优衣库",
          name: "张二狗服装店",
          ghf: "河北dayali",
          price: "1990.00-2000.00",
          is_sj: true,
          is_tj: false,
          status: "审核已通过",
          inventory: "40",
          looknum: "2",
          sort: 1
        },
        {
          id: 1,
          image_url:
            "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3273639253,4215472728&fm=26&gp=0.jpg",
          cname: "爆款夏季休闲长裤",
          pp: "优衣库",
          name: "张二狗服装店",
          ghf: "河北dayali",
          price: "1990.00-2000.00",
          is_sj: true,
          is_tj: false,
          status: "审核已通过",
          inventory: "40",
          looknum: "2",
          sort: 1
        }
      ], //商户列表
      keyword: "",
      page: 1
    };
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  methods: {
    search() {},
    clear() {},
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getOrderList();
      } else {
        this.getOrderList();
      }
    },
    downPage() {
      // 下一页
      if (this.tableData.length == 10) {
        this.page++;
        console.log(this.page);
        this.getOrderList();
        console.log(this.tableData.length);
        if (this.tableData.length == 0) {
          this.$message("请添加新品牌");
          this.page--;
          this.getOrderList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        .input_box {
          margin-right: 20px;
          width: 240px;
        }
      }
    }
    // table
    .el-table {
      box-shadow: 0 0 3px #f1f1f1;
      height: 85%;
      padding-left: 20px;
      .cell {
        text-align: center !important;
      }
    }
    // table里面的子行
    .table_scope_line {
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      text-align: center;
    }
    .table_button_line {
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      text-align: center;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}
</style>
